module.exports = __webpack_public_path__ + "img/aperio.bfe0ede1.jpg";